import React from 'react'
import { TileFooter } from '@placeme/components/atoms'
import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'
import { useSelector } from 'react-redux'
import { RootState } from 'apps/placeme/src/redux/store'
import { SPECIAL_TILE_COSTS } from '@placeme/components/molecules/SectionTile/SectionTile'
import {
  AttractivenessFormDataObject,
  FormFieldValue,
} from '../@types/IAttractivenessTileData'
import { AttractivenessFormElementWrapper } from './AttractivenessFormElementWrapper'

const Description = styled.span(({
  theme: {
    palette,
    typography,
  },
}) => css`
  color: ${palette.dark.normal};
  font-size: ${typography.main.pt_15_medium.fontSize};
  font-weight: ${typography.main.pt_15_medium.fontWeight};
  line-height: ${typography.main.pt_15_medium.lineHeight};
`)

const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;
`

interface AttractivenessFormProps {
  formDataObject: AttractivenessFormDataObject
  setFormValue: (key: string, value: FormFieldValue) => void
  handleSubmit: () => void
  handleDeleteTile: () => void
  areAllFieldsFilled: boolean
}

export const AttractivenessForm: React.FC<AttractivenessFormProps> = ({
  formDataObject,
  setFormValue,
  handleSubmit,
  handleDeleteTile,
  areAllFieldsFilled,
}) => {
  const { t } = useTranslation()
  const { formElementData } = formDataObject
  const { currentSubscriptionData } = useSelector((state: RootState) => state.location)

  return (
    <>
      <DescriptionWrapper>
        <Description>{t('placeme.attractiveness.tile.description_1')}</Description>
        <Description>{t('placeme.attractiveness.tile.description_2')}</Description>
      </DescriptionWrapper>

      <AttractivenessFormElementWrapper
        elements={formElementData}
        setFormValue={setFormValue}
      />

      <TileFooter
        disabled={!areAllFieldsFilled}
        isUnlimited={currentSubscriptionData?.value?.planExact?.includes('unlimited') || currentSubscriptionData?.value?.plan === 'white'}
        label={t('generic.apply')}
        onAccept={handleSubmit}
        onCancel={handleDeleteTile}
        value={SPECIAL_TILE_COSTS.attractiveness}
      />
    </>
  )
}
